import { Button } from 'react-aria-components'
import { useClearRefinements } from 'react-instantsearch'

type AlgoliaNoResultsProps = {
  callbacks?: {
    refine: () => void
  }
}

export default function AlgoliaNoResults({
  callbacks,
}: AlgoliaNoResultsProps): React.ReactNode {
  const { refine: clearRefinement } = useClearRefinements({
    includedAttributes: ['taxonomies.genre', 'query'],
  })

  return (
    <div className="text-center my-[10%]">
      <h3 className="mb-sm">No results found</h3>
      <p className="p--lg">
        Please try a different search term or browse our categories
      </p>

      <Button
        onClick={() => {
          clearRefinement()
          if (callbacks?.refine) {
            callbacks.refine()
          }
        }}
        className="btn btn--sm btn--solid py-sm px-lg w-auto whitespace-nowrap mt-lg">
        Clear and try again
      </Button>
    </div>
  )
}
